/**
 * Route for `igaming-retention-churn-by-brand`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingRetentionChurnByBrandPage } from "../features/igaming-retention-churn-by-brand/IgamingRetentionChurnByBrandPage";

export const igamingRetentionChurnByBrandRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-retention-churn-by-brand",
	component: IgamingRetentionChurnByBrandPage,
});

export default igamingRetentionChurnByBrandRoute;
